export default __webpack_public_path__ + "static/media/cancel_outline_white.6073104e.png";